import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ContactTagDef, listContactTags } from 'api/contact-tags';
import { dispatch } from 'store';

// אוצר תגיות איש הקשר של החברה — נטען פעם אחת (dataLoader) ומתעדכן ממסך התגיות.
// נפרד מ-OwnerCompany.ChatUserLabels (תגיות שיחה) בכוונה: שתי רשימות, שני מסכים.

type ContactTagsState = {
  items: ContactTagDef[];
  loaded: boolean;
};

const initialState: ContactTagsState = { items: [], loaded: false };

const contactTagsSlice = createSlice({
  name: 'contactTags',
  initialState,
  reducers: {
    setContactTags(state, action: PayloadAction<ContactTagDef[]>) {
      state.items = action.payload;
      state.loaded = true;
    },
    upsertContactTag(state, action: PayloadAction<ContactTagDef>) {
      const idx = state.items.findIndex((t) => t.id === action.payload.id);
      if (idx === -1) state.items.push(action.payload);
      else state.items[idx] = action.payload;
    },
    removeContactTag(state, action: PayloadAction<number>) {
      state.items = state.items.filter((t) => t.id !== action.payload);
    },
    resetContactTags() {
      return initialState;
    },
  },
});

export default contactTagsSlice.reducer;
export const { setContactTags, upsertContactTag, removeContactTag, resetContactTags } = contactTagsSlice.actions;

/** טעינת האוצר מהשרת; כישלון משאיר את הרשימה הקיימת */
export async function loadContactTags(): Promise<void> {
  const tags = await listContactTags();
  if (tags) dispatch(setContactTags(tags));
}

/** רק תגיות פעילות, בסדר התצוגה — מה שבוררי ההצמדה מציעים */
export function selectActiveContactTags(items: ContactTagDef[]): ContactTagDef[] {
  return items
    .filter((t) => t.isActive)
    .slice()
    .sort((a, b) => a.sortOrder - b.sortOrder || a.name.localeCompare(b.name, 'he'));
}
